import Dexie from 'dexie';

const db = new Dexie('EventAttendanceDB');
db.version(1).stores({
  events: '_id, name, startDate, endDate, location',
  devices: '_id, deviceId, name, eventId, status',
  users: '_id, customId, name, email, eventId, status',
  admins: '_id, name, email, role',
  sessions: '_id, customId, name, email, eventId, entryDevice, exitDevice, status, entryTime, synced',
  syncQueue: '++id, endpoint, method, body, timestamp, retryCount'
});

export default db;